import { NavigationProvider } from '@portals/core/src/components/Navigation/Provider';
import { ProductComparisonContextProvider } from '@portals/core/src/components/ProductComparison/ProductComparisonContext';
import React, { PropsWithChildren, useMemo } from 'react';
import { CookiesProvider } from 'react-cookie';

import { GirokontoContextProvider } from './girokonto-context';
import { ServiceBoxContextProvider } from './service-box';
import { SparkasseAssignmentFormProvider } from './sparkasse-assignment-form';
import { ThematicLinkContextProvider } from './thematic-link';
import { UserContextProvider } from './user-context';
import { VistedPagesProvider } from './visited-pages';

export const RootContextCollection: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const cookieOptions = useMemo(() => {
    if (typeof window !== 'undefined' && !window.location.hostname.endsWith(process.env.COOKIE_DOMAIN)) {
      return {
        domain: window.location.hostname,
        secure: true,
        sameSite: 'none' as const,
        path: '/',
      };
    }

    if (process.env.COOKIE_DOMAIN) {
      return {
        domain: process.env.COOKIE_DOMAIN,
        secure: true,
        sameSite: 'none' as const,
        path: '/',
      };
    }

    return {
      secure: true,
      sameSite: 'none' as const,
      path: '/',
    };
  }, []);

  return (
    <NavigationProvider>
      <UserContextProvider>
        <CookiesProvider defaultSetOptions={cookieOptions}>
          <ThematicLinkContextProvider>
            <VistedPagesProvider>
              <SparkasseAssignmentFormProvider>
                <ServiceBoxContextProvider>
                  <ProductComparisonContextProvider>
                    <GirokontoContextProvider>{children}</GirokontoContextProvider>
                  </ProductComparisonContextProvider>
                </ServiceBoxContextProvider>
              </SparkasseAssignmentFormProvider>
            </VistedPagesProvider>
          </ThematicLinkContextProvider>
        </CookiesProvider>
      </UserContextProvider>
    </NavigationProvider>
  );
};
